// Runtime configuration service

export interface RuntimeConfig {
  react_app_api_url: string
  can_change_amount?: boolean
}

let config: RuntimeConfig = {} as RuntimeConfig;

export async function loadConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch('/config.json');
    if (!response.ok)
      throw new Error(`Failed to load config: ${response.status}`);
    config = await response.json();
    console.log('Runtime config loaded:', config);
  } catch (err) {
    console.warn('Failed to load runtime config, using environment variables as fallback:', err);
  }

  return config;
}

export function getConfig(): RuntimeConfig {
  return config;
}

export function getApiUrl(): string {
  console.log('Runtime config loaded:', config);
  const apiUrl = config.react_app_api_url ?? process.env.REACT_APP_API_URL
  return apiUrl ?? 'http://localhost:42301';
}

export function canChangeAmount(): boolean {
  return config.can_change_amount ?? true;
}

// PWA support removed
